import React,{Component} from 'react'

import {
  Typography,
} from 'material-ui'

const style = {
  unauthorizedContainer:{
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
    height:'inherit',
    flexDirection:'column',
  },
  unauthorized:{
    color: 'rgba(173,173,173,0.7)',
    textShadow: '1px 4px 6px white, 0 0 0 black, 1px 4px 6px white',
    marginBottom:'11px',
  },
}

export default class UnauthorizedText extends Component{
  render(){
    return(
      <div style={style.unauthorizedContainer}>
        <Typography type='display1' style={style.unauthorized}>{this.props.text}</Typography>
        <Typography type='subheading' style={style.unauthorized}>{this.props.subText}</Typography>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/UnauthorizedText.js